/* eslint-disable max-len */
import { handleActions } from 'redux-actions';

import user from './user/reducer';
import options from './options/reducer';
import userType from './userType/reducer';
import templates from './templates/reducer';
import fieldTypes from './fieldTypes/reducer';
import customFields from './customFields/reducer';
import priceFormulas from './priceFormulas/reducer';
import fieldsMapping from './fieldsMapping/reducer';
import optionSources from './optionSources/reducer';
import pageTemplates from './pageTemplates/reducer';
import customProtocolRules from './customProtocolRules/reducer';
import systemEmailTemplates from './systemEmailTemplates/reducer';

export default handleActions(
  {
    ...user,
    ...options,
    ...userType,
    ...templates,
    ...fieldTypes,
    ...customFields,
    ...priceFormulas,
    ...optionSources,
    ...fieldsMapping,
    ...pageTemplates,
    ...customProtocolRules,
    ...systemEmailTemplates,
  },
  {
    users: {},
    options: {},
    userTypes: {},
    templates: {},
    loggedUser: {
      columnSettings: {},
    },
    fieldTypes: {},
    customFields: {},
    priceFormulas: {},
    optionSources: {},
    fieldsMapping: {},
    pageTemplates: {},
    passwordPolicy: {},
    customProtocolRules: {},
    systemEmailTemplates: {},
  },
);
